export default "__VITE_ASSET__04018413__"